import {VDateInput} from 'vuetify/labs/VDateInput'
import {VCalendar} from 'vuetify/labs/VCalendar'

export const isDev = false
export function vuetifyConfiguration() {
  const options = {"ssr":true}
  
  
  options.components = {VDateInput,VCalendar}
  
  return options
}

